import { ArrowRight, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { IMG, CONTACT } from "@/lib/site";
import { useT } from "@/lib/i18n";

const SesionHero = () => {
  const t = useT();
  return (
    <section className="relative overflow-hidden" data-testid="page-sesion-gratuita">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-sand/60 via-ivory to-ivory" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-12 md:pt-20 pb-16 md:pb-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-7"
          >
            <span className="inline-flex items-center gap-2 bg-terracotta/15 text-terracotta rounded-full px-4 py-2 text-[11px] tracking-[0.25em] uppercase mb-7">
              <span className="w-2 h-2 rounded-full bg-terracotta animate-pulse" />
              {t("free.hero.badge")}
            </span>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-charcoal leading-[0.98]">
              {t("free.hero.title1")} <span className="italic text-terracotta">{t("free.hero.title2")}</span>,<br />
              {t("free.hero.title3")}
            </h1>
            <p className="mt-7 text-lg md:text-xl leading-relaxed text-charcoal/75 font-light max-w-xl">
              {t("free.hero.lead")}
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href="#solicitar"
                data-testid="hero-cta-solicitar"
                className="group inline-flex items-center justify-center gap-2 bg-charcoal text-ivory rounded-full px-8 py-4 text-sm font-medium hover:bg-terracotta transition-all"
              >
                {t("free.hero.btnPrimary")}
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href={CONTACT.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-cta-whatsapp"
                className="inline-flex items-center justify-center gap-2 border border-charcoal/25 text-charcoal rounded-full px-8 py-4 text-sm font-medium hover:bg-charcoal hover:text-ivory transition-all"
              >
                <MessageCircle size={16} /> {t("free.hero.btnWhatsapp")}
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-40 h-40 rounded-full bg-sage/20 blur-3xl" />
              <div className="aspect-[4/5] rounded-tr-[5rem] rounded-bl-[5rem] overflow-hidden bg-sand">
                <img
                  src={IMG.handsHolding}
                  alt="Acompañamiento cuerpo-mente"
                  className="w-full h-full object-cover"
                  fetchPriority="high"
                  decoding="async"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SesionHero;
